import React from "react"
import {Moment} from "moment";
import {Col, DatePicker} from "antd";
import {Label} from "../../../../../common/Label/Label";
import styles from "../../../Style/DatasetInfo.module.scss"
import {copyDefaultTimeRange} from "../../../../../../utils/dateRange";
const { RangePicker } = DatePicker;

export const DateRangeSelector = ({
  id,
  dateRange,
  disabledDate,
  onDateChange,
  isDisabled
}: {
  id: string;
  dateRange?: [Moment, Moment];
  disabledDate: (current: Moment) => boolean;
  onDateChange: (value: any) => void;
  isDisabled: boolean;
}) => {

  // TODO: Find the correct types for dates Antd
  const handleDateChange = (dates: any) => {
    if (dates && dateRange) {
      const updatedDates = [
        copyDefaultTimeRange(dateRange[0], dates[0]),
        copyDefaultTimeRange(dateRange[1], dates[1])
      ]
      onDateChange(updatedDates)
    }
  }

  return (
    <Col span={12}>
      <Label
        label={
          <div className={styles.DateLabel}>
            <span style={{ flexBasis: '50%' }}>Start Date</span>
            <span>End Date</span>
          </div>
        }
      >
        <RangePicker
          id={id}
          value={dateRange}
          disabledDate={disabledDate}
          format={['YYYY-MM-DD', 'YYYY-MM-DD']}
          style={{ width: '100%' }}
          onChange={handleDateChange}
          disabled={isDisabled}
        />
      </Label>
    </Col>
  );
};
